(() => {
  const STYLE_ID = 'casa-bauhaus-chat-style';

  const styles = `
    .chat-toggle {
      width: 5.6rem !important;
      min-width: 5.6rem !important;
      height: 5.6rem !important;
      padding: 0 !important;
      justify-content: center !important;
      border: 0.1rem solid rgba(255, 255, 255, 0.38) !important;
      border-radius: 0.2rem !important;
      box-shadow: 0 0.6rem 2.2rem rgba(0, 0, 0, 0.2) !important;
    }

    .chat-toggle svg {
      width: 2.6rem !important;
      height: 2.6rem !important;
    }

    .chat-title {
      position: absolute !important;
      width: 0.1rem !important;
      height: 0.1rem !important;
      padding: 0 !important;
      margin: -0.1rem !important;
      overflow: hidden !important;
      clip: rect(0, 0, 0, 0) !important;
      white-space: nowrap !important;
      border: 0 !important;
    }

    .chat-notification {
      top: -0.7rem !important;
      right: -0.7rem !important;
      min-width: 2rem !important;
      height: 2rem !important;
      padding: 0 0.5rem !important;
      color: #111 !important;
      background: #f7f7f3 !important;
      border: 0.1rem solid #111 !important;
      border-radius: 50% !important;
      font-size: 1.1rem !important;
      line-height: 1.8rem !important;
    }

    .chat-ui {
      border-radius: 0.2rem !important;
      box-shadow: 0 1.2rem 4rem rgba(0, 0, 0, 0.2) !important;
    }

    .store-info-heading {
      font-family: var(--font-heading-family, Georgia, serif) !important;
      letter-spacing: 0 !important;
    }

    .outline-button,
    .composer-bar__box,
    .chat-app--close-button {
      border-radius: 0.2rem !important;
    }

    .chat-app--close-button {
      box-shadow: 0 0.6rem 2.2rem rgba(0, 0, 0, 0.18) !important;
    }

    @media (prefers-reduced-motion: reduce) {
      *, *::before, *::after {
        scroll-behavior: auto !important;
        transition-duration: 0.01ms !important;
      }
    }
  `;

  function setHostStyle(host, property, value) {
    if (host.style.getPropertyValue(property) !== value) {
      host.style.setProperty(property, value);
    }
  }

  function applyChatDesign(host) {
    const root = host.shadowRoot;
    if (!root) return false;

    if (!root.getElementById(STYLE_ID)) {
      const style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = styles;
      root.append(style);
    }

    const isOpen = host.getAttribute('is-open') === 'true';
    if (isOpen) {
      if (host.style.getPropertyValue('width')) host.style.removeProperty('width');
      if (host.style.getPropertyValue('height')) host.style.removeProperty('height');
    } else {
      setHostStyle(host, 'width', '56px');
      setHostStyle(host, 'height', '56px');
    }

    const mobile = window.matchMedia('(max-width: 749px)').matches;
    setHostStyle(host, 'right', mobile ? '12px' : '20px');
    setHostStyle(host, 'bottom', mobile ? '12px' : '20px');

    const toggle = root.querySelector('[data-spec="toggle-button"]');
    if (toggle && toggle.getAttribute('aria-label') !== 'Chat with Casa Bauhaus') {
      toggle.setAttribute('aria-label', 'Chat with Casa Bauhaus');
    }

    if (!root.casaBauhausObserver) {
      root.casaBauhausObserver = new MutationObserver(() => {
        requestAnimationFrame(() => applyChatDesign(host));
      });
      root.casaBauhausObserver.observe(root, { childList: true, subtree: true });
    }

    return true;
  }

  function initialize() {
    const host = document.getElementById('ShopifyChat');
    if (!host || !applyChatDesign(host)) return false;

    const observer = new MutationObserver(() => {
      requestAnimationFrame(() => applyChatDesign(host));
    });
    observer.observe(host, { attributes: true, childList: true });

    window.matchMedia('(max-width: 749px)').addEventListener('change', () => applyChatDesign(host));
    return true;
  }

  if (initialize()) return;

  const pageObserver = new MutationObserver(() => {
    if (initialize()) pageObserver.disconnect();
  });
  pageObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
